export default "__VITE_ASSET__D6is08mx__"